<!-- Sugerencia de Pedidos — Etapa 1 de la propuesta 2026-07-23, rediseño
     2026-07-27. Componente reutilizable con dos superficies que COMPARTEN el
     calendario y las tarjetas de producto (ng-template al final del archivo):
     página de estación (una card con la rejilla abierta) y sección del Tablero
     (boardMode: tabla de una fila por estación, con el carril de días alineado
     entre filas; el calendario grande solo baja al expandir). El envoltorio de
     página (container/row/col) lo pone cada host. -->
<div class="sug-page" [class.sug-page--board]="boardMode">

  <!-- Loader -->
  <div class="sug-card" *ngIf="loading">
    <div class="sug-empty">
      <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
      <b>Calculando la sugerencia de la semana…</b>
      <span>Proyección de inventario y pronóstico de ventas por estación.</span>
    </div>
  </div>

  <!-- Error -->
  <div class="sug-card" *ngIf="!loading && errorMsg">
    <div class="sug-empty">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      <b>No se pudo calcular la sugerencia</b>
      <span>{{ errorMsg }}</span>
      <button class="sug-btn-row sug-empty__retry" (click)="getData()">Reintentar</button>
    </div>
  </div>

  <ng-container *ngIf="!loading && !errorMsg">
    <!-- Cabecera: título + base del dato + selector de semana + resumen -->
    <div class="sug-card sug-header-card">
      <div class="sug-header">
        <span class="sug-title">Sugerencia de Pedidos — {{ weekRangeLabel }}</span>
        <span class="sug-basis-chip">
          <i class="fa fa-tint" aria-hidden="true"></i>
          Inventario de hoy · pronóstico a 14 días
        </span>
        <!-- Refresco en caliente tras enviar una solicitud: la vista se queda
             puesta y solo se avisa que se está recalculando. -->
        <span class="sug-refreshing" *ngIf="refreshing">
          <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
          Actualizando la sugerencia…
        </span>
        <span class="sug-spacer"></span>
        <select class="sug-week-select" [(ngModel)]="weekMode" (ngModelChange)="onWeekModeChange()">
          <option value="next">Semana siguiente</option>
          <option value="current">Semana actual</option>
        </select>
      </div>

      <!-- Resumen del alcance. NO se usa summary.stations_at_risk del back: ese
           contador también suma las estaciones de riesgo 'advertencia', que son
           justo las que YA tienen un pedido pendiente cubriendo el mínimo. -->
      <div class="sug-summary" *ngIf="boardMode && stations.length">
        <span class="sug-summary__pill sp-green" *ngIf="totalPipes">
          <i class="fa fa-truck" aria-hidden="true"></i>
          {{ totalPipes }} {{ totalPipes === 1 ? 'pipa sugerida' : 'pipas sugeridas' }} ·
          {{ totalLiters | number: '1.0-0' }} lts
        </span>
        <span class="sug-summary__pill sp-red" *ngIf="stationsToOrder">
          {{ stationsToOrder }} {{ stationsToOrder === 1 ? 'estación por pedir' : 'estaciones por pedir' }}
        </span>
        <span class="sug-summary__pill sp-warn" *ngIf="stationsCovered">
          {{ stationsCovered }} con pedido en camino
        </span>
        <span class="sug-summary__pill sp-green" *ngIf="!totalPipes">
          <i class="fa fa-check" aria-hidden="true"></i>
          Sin pedidos necesarios esta semana
        </span>
      </div>
    </div>

    <!-- Sin estaciones -->
    <div class="sug-card" *ngIf="!stations.length">
      <div class="sug-empty">
        <i class="fa fa-truck" aria-hidden="true"></i>
        <b>Sin estaciones para sugerir</b>
        <span>Tu usuario no tiene estaciones asignadas al flujo de pedidos.</span>
      </div>
    </div>

    <!-- ============ SUPERFICIE ESTACIÓN: una card con todo abierto ============ -->
    <ng-container *ngIf="!boardMode">
      <div class="sug-card" *ngFor="let station of stations">
        <div class="sug-station">
          <span class="sug-station__name">{{ station.name }}</span>
          <span class="sug-count-chip" *ngIf="station.pipesTotal">
            <i class="fa fa-truck" aria-hidden="true"></i>
            {{ station.pipesTotal }} {{ station.pipesTotal === 1 ? 'pipa sugerida' : 'pipas sugeridas' }}
          </span>
          <span class="sug-count-chip ok" *ngIf="!station.pipesTotal">
            <i class="fa fa-check" aria-hidden="true"></i>
            Sin pedido necesario
          </span>
          <span class="sug-spacer"></span>
          <button
            class="sug-btn-cta"
            *ngIf="canRequest && station.pipesTotal"
            (click)="useAllForStation(station)"
          >
            <i class="fa fa-magic" aria-hidden="true"></i>
            Usar todas ({{ station.pipesTotal }} {{ station.pipesTotal === 1 ? 'pipa' : 'pipas' }})
          </button>
        </div>

        <ng-container *ngTemplateOutlet="calendarTpl; context: { $implicit: station }"></ng-container>
        <ng-container *ngTemplateOutlet="productsTpl; context: { $implicit: station }"></ng-container>

        <div class="sug-hint" *ngIf="canRequest && station.pipesTotal">
          Al usar una sugerencia solo capturas el <b>PO</b> y el <b>material</b> — fecha, capacidad y tipo van
          prellenados.
        </div>
      </div>
    </ng-container>

    <!-- ============ SUPERFICIE TABLERO: una fila por estación ============ -->
    <div class="sug-card" *ngIf="boardMode && stations.length">
      <!-- La leyenda va ARRIBA de la tabla: con muchas estaciones, al pie
           obligaba a scrollear hasta el final para entender los símbolos. -->
      <div class="sugb__legend">
        <span><i class="sugb__dot"></i> Pipa sugerida</span>
        <span><i class="sugb__dot sugb__dot--ordered"></i> Pipa ya pedida</span>
        <span><i class="sugb__mark-alert"></i> Sigue bajo el mínimo</span>
        <span class="sugb__legend-hint">Clic en una estación para ver su calendario.</span>
      </div>

      <div class="sugb-wrap">
      <table class="sugb">
        <thead>
          <tr>
            <th class="sugb__c-toggle"></th>
            <th class="sugb__c-name">Estación</th>
            <th class="sugb__c-risk">Riesgo</th>
            <th class="sugb__c-demand">Qué pedir</th>
            <th class="sugb__c-rail">
              <div class="sugb__rail sugb__rail--caption">
                <span class="sugb__rail-week" *ngFor="let week of headWeeks">
                  <span class="sugb__week-cap" [class.is-target]="week.isTarget">{{ week.caption }}</span>
                </span>
              </div>
              <div class="sugb__rail">
                <span class="sugb__rail-week" *ngFor="let week of headWeeks">
                  <span
                    class="sugb__tick-head"
                    *ngFor="let day of week.days"
                    [class.is-past]="day.state === 'past'"
                    [class.is-today]="day.state === 'today'"
                  >{{ day.dayNumber }}</span>
                </span>
              </div>
            </th>
            <th class="sugb__c-total">Pipas</th>
            <th class="sugb__c-action"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let station of stations; let odd = odd">
            <tr
              class="sugb__row"
              [class.is-odd]="odd"
              [class.is-open]="station.expanded"
              [class.is-quiet]="!station.pipesTotal"
              (click)="toggleStation(station)"
            >
              <td class="sugb__c-toggle">
                <span class="sug-toggle" [class.open]="station.expanded">&#9654;</span>
              </td>
              <td class="sugb__c-name">{{ station.name }}</td>
              <td class="sugb__c-risk">
                <span class="sug-risk" [ngClass]="'risk-' + station.risk">{{ station.riskLabel }}</span>
              </td>
              <td class="sugb__c-demand">
                <ng-container *ngIf="station.demand.length; else quietReason">
                  <span class="sug-chip" *ngFor="let item of station.demand" [ngClass]="item.chipClass">
                    {{ item.label }} {{ item.pipes }}
                  </span>
                </ng-container>
                <ng-template #quietReason>
                  <span class="sugb__quiet">{{ station.summaryText }}</span>
                </ng-template>
              </td>
              <td class="sugb__c-rail">
                <div class="sugb__rail">
                  <span class="sugb__rail-week" *ngFor="let week of station.weeks">
                    <span
                      class="sugb__tick"
                      *ngFor="let day of week.days"
                      [class.is-past]="day.state === 'past'"
                      [class.is-today]="day.state === 'today'"
                      [class.is-alert]="day.belowMin"
                      [title]="day.tooltip"
                    >
                      <i class="sugb__dot" *ngIf="day.suggestedCount">{{ day.suggestedCount > 1 ? day.suggestedCount : '' }}</i>
                      <i class="sugb__dot sugb__dot--ordered" *ngIf="!day.suggestedCount && day.orderedCount"></i>
                    </span>
                  </span>
                </div>
              </td>
              <td class="sugb__c-total">
                <b *ngIf="station.pipesTotal">{{ station.pipesTotal }}</b>
                <span class="sugb__dash" *ngIf="!station.pipesTotal">—</span>
              </td>
              <td class="sugb__c-action">
                <button
                  class="sug-btn-row"
                  *ngIf="canRequest && station.pipesTotal"
                  (click)="useAllForStation(station, $event)"
                >
                  Usar
                </button>
              </td>
            </tr>

            <!-- Detalle: el MISMO calendario y las MISMAS tarjetas de producto
                 de la vista de estación (una estación abierta a la vez). -->
            <tr class="sugb__detail" *ngIf="station.expanded">
              <td colspan="7">
                <ng-container *ngTemplateOutlet="calendarTpl; context: { $implicit: station }"></ng-container>
                <ng-container *ngTemplateOutlet="productsTpl; context: { $implicit: station }"></ng-container>
                <div class="sug-hint" *ngIf="canRequest && station.pipesTotal">
                  Al usar una sugerencia solo capturas el <b>PO</b> y el <b>material</b> — fecha, capacidad y tipo
                  van prellenados.
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      </div>
    </div>
  </ng-container>
</div>

<!-- ============ Rejilla de calendario de una estación ============
     Una sola rejilla por estación (antes eran tres tiras, una por producto):
     columnas = días de la semana ISO, filas = semanas, y las pipas son eventos
     DENTRO del día. Cubre el horizonte completo del back (hoy → fin de la
     semana objetivo), así que las pipas sugeridas anteriores al lunes objetivo
     también tienen celda. -->
<ng-template #calendarTpl let-station>
  <div class="sug-cal">
    <div class="sug-cal__dow">
      <span *ngFor="let day of weekdays">{{ day }}</span>
    </div>

    <div class="sug-cal__week" *ngFor="let week of station.weeks">
      <div class="sug-cal__caption" [class.is-target]="week.isTarget">{{ week.caption }}</div>
      <div class="sug-cal__row">
        <div
          class="sug-cal__day"
          *ngFor="let day of week.days"
          [class.is-past]="day.state === 'past'"
          [class.is-today]="day.state === 'today'"
          [class.is-target]="week.isTarget"
          [class.is-alert]="day.belowMin"
          [title]="day.tooltip"
        >
          <span class="sug-cal__date">
            {{ day.dayNumber }}<em *ngIf="day.monthLabel">{{ day.monthLabel }}</em>
            <b *ngIf="day.state === 'today'">Hoy</b>
          </span>

          <span
            class="sug-cal__event"
            *ngFor="let pipe of day.pipes"
            [class.is-ordered]="pipe.kind === 'ordered'"
            [class.is-clickable]="canRequest && pipe.kind === 'suggested'"
            [ngClass]="'p-' + pipe.product"
            [title]="pipe.kind === 'ordered' ? orderedTooltip(pipe) : suggestedTooltip(pipe)"
            (click)="usePipe(station, pipe, $event)"
          >
            <i class="fa fa-truck" aria-hidden="true"></i>
            <b>{{ pipe.label }}</b>
            {{ pipe.liters | number: '1.0-0' }}
          </span>
        </div>
      </div>
    </div>

    <div class="sug-cal__legend">
      <span><i class="sug-cal__key"></i> Pipa sugerida{{ canRequest ? ' — clic para solicitarla' : '' }}</span>
      <span><i class="sug-cal__key is-ordered"></i> Pipa ya pedida</span>
      <span><i class="sug-cal__key is-alert"></i> Sigue bajo el mínimo</span>
    </div>
  </div>
</ng-template>

<!-- ============ Tarjetas "cómo estás hoy" por producto ============ -->
<ng-template #productsTpl let-station>
  <div class="sug-prod">
    <div class="sug-prod__card" *ngFor="let product of station.products">
      <div class="sug-prod__head">
        <span class="sug-chip" [ngClass]="product.chipClass">{{ product.label }}</span>
        <span class="sug-risk" [ngClass]="'risk-' + product.risk">{{ product.riskLabel }}</span>
      </div>

      <div class="sug-prod__value" *ngIf="product.todayValue !== null; else noStock">
        {{ product.todayValue | number: '1.0-0' }}<em>lts hoy</em>
      </div>
      <ng-template #noStock>
        <div class="sug-prod__value sug-prod__value--empty">Sin lectura</div>
      </ng-template>

      <div class="sug-prod__days" *ngIf="product.todayDays !== null">
        {{ product.todayDays | number: '1.1-1' }} días sobre el mínimo
        <span class="sug-prod__rule" *ngIf="product.governs === 'target'"
          title="La estación capturó un porcentaje objetivo: cada día debe cerrar en el objetivo o arriba, con la pipa que suele pedir, y la Regla de días no se mide. Solo lo acotan el mínimo y el tope.">
          · manda el objetivo
        </span>
        <span class="sug-prod__rule" *ngIf="product.governs === 'min'"
          title="Las dos reglas no se suman: se cumple la que pide más litros. Aquí pide más el mínimo que los días de venta.">
          · manda el mínimo
        </span>
        <span class="sug-prod__rule" *ngIf="product.governs !== 'min' && product.governs !== 'target'">· se pide con {{ product.thresholdDays }} días de venta</span>
      </div>

      <div class="sug-tank" *ngIf="product.fillPct !== null">
        <i
          class="sug-tank__fill"
          [class.is-low]="product.todayDays !== null && product.todayDays < product.arrivalDays"
          [style.width.%]="product.fillPct"
        ></i>
        <i class="sug-tank__rule" *ngIf="product.rulePct !== null" [style.left.%]="product.rulePct"></i>
      </div>

      <p class="sug-prod__reason">{{ product.reasonText }}</p>

      <div class="sug-prod__foot" *ngIf="product.suggestions.length">
        <button class="sug-btn-row" *ngIf="canRequest" (click)="useProduct(station, product)">
          Usar {{ product.suggestions.length }} {{ product.suggestions.length === 1 ? 'pipa' : 'pipas' }}
        </button>
        <span class="sug-why" (click)="openWhy(station, product)">
          <i class="fa fa-info-circle" aria-hidden="true"></i> ¿Por qué?
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal "¿Por qué esta sugerencia?" (anatomía op-confirm del flujo) -->
<div class="sug-modal-backdrop" *ngIf="whyOpen && whyContext" (click)="closeWhy()">
  <div class="sug-op-confirm" (click)="$event.stopPropagation()">
    <div class="sug-op-head">
      <span class="sug-op-circ">?</span>
      <h3>¿Por qué esta sugerencia?</h3>
    </div>
    <div class="sug-op-body">
      <div class="sug-op-subject">
        <span class="sug-chip" [ngClass]="whyContext.product.chipClass">{{ whyContext.product.label }}</span>
        <span>{{ whyContext.stationName }} · {{ whyContext.dateLabel }}</span>
      </div>
      <div class="sug-why-box red">
        <span class="wl">Sin pedido · {{ whyContext.dayLabel }}</span>
        <span class="wv">{{ whyContext.suggestion.reason?.inventory_before | number: '1.0-0' }} lts</span>
        <span class="ws" *ngIf="whyContext.withoutDays !== null">
          <ng-container *ngIf="whyContext.withoutDays < 0; else daysOver">por debajo del mínimo</ng-container>
          <ng-template #daysOver>{{ whyContext.withoutDays | number: '1.1-1' }} días sobre el mínimo</ng-template>
          — la pipa debe llegar con al menos {{ whyContext.product.arrivalDays }}
        </span>
      </div>
      <div class="sug-why-box green">
        <span class="wl">
          <i class="fa fa-truck" aria-hidden="true"></i>&nbsp;
          Con la pipa sugerida · +{{ whyContext.suggestion.liters | number: '1.0-0' }} lts
        </span>
        <span class="wv" *ngIf="whyContext.withValue !== null">{{ whyContext.withValue | number: '1.0-0' }} lts</span>
        <span class="ws" *ngIf="whyContext.withDays !== null">{{ whyContext.withDays | number: '1.1-1' }} días sobre el mínimo ✓</span>
      </div>

      <div class="sug-why-sec">¿Cómo se calculó?</div>
      <dl class="sug-terms">
        <dt>Inventario hoy ({{ whyContext.product.todayBasis === 'real' ? 'real' : 'teórico' }})</dt>
        <dd><b>{{ whyContext.product.todayValue | number: '1.0-0' }} lts</b></dd>
        <dt>Venta pronosticada</dt>
        <dd>− {{ whyContext.suggestion.reason?.daily_sale | number: '1.0-0' }} lts/día</dd>
        <dt>Pipas ya pedidas antes del {{ whyContext.dayLabel }}</dt>
        <dd>{{ whyContext.pipesBefore | number: '1.0-0' }} lts</dd>
        <dt>Tamaño de la pipa</dt>
        <dd>
          {{
            whyContext.habitText ||
              (whyContext.sizeBasis === 'target'
                ? 'La que alcanza el inventario objetivo de la estación'
                : 'La más grande que cabe bajo el tope de llenado')
          }}
        </dd>
        <dt>Pedirla a más tardar</dt>
        <dd>
          <b>{{ whyContext.urgent ? 'hoy' : whyContext.orderByLabel }}</b>
        </dd>
      </dl>
      <div class="sug-op-note">
        El calendario proyecta el nivel del tanque día a día: baja con la venta pronosticada y el camión lo rellena.
        Las dos reglas no se suman: se cumple la que pide más litros.
        <ng-container *ngIf="whyContext.product.governs === 'target'">Aquí manda el porcentaje objetivo: cada día debe cerrar en el objetivo o arriba ({{ whyContext.product.ruleLevel | number: '1.0-0' }} lts es el nivel con el que se pide); la pipa es la que la estación suele pedir, la Regla de días no se mide y solo acotan el mínimo y el tope.</ng-container>
        <ng-container *ngIf="whyContext.product.governs === 'min'">Aquí manda el mínimo ({{ whyContext.product.minOperative | number: '1.0-0' }} lts y medio día de venta), porque {{ whyContext.product.thresholdDays }} días de venta piden menos.</ng-container>
        <ng-container *ngIf="whyContext.product.governs !== 'min' && whyContext.product.governs !== 'target'">Aquí mandan los {{ whyContext.product.thresholdDays }} días de venta ({{ whyContext.product.ruleLevel | number: '1.0-0' }} lts).</ng-container>
        El tamaño es el que la estación más repite en sus entregas de las últimas 2 semanas, no el promedio (los litros son los registrados en la compra, redondeados a los 500 más cercanos; lo del mismo día se suma; si empatan, el más cercano a la mediana de sus entregas y, si siguen empatados, el de la entrega más reciente); sin historial, la más grande que cabe bajo el tope de llenado, sin
        cubrir más de 14 días de venta. La Regla se configura por estación en Análisis de Pedido, y el pedido pasa por el candado de
        espacio como cualquier solicitud.
      </div>
    </div>
    <div class="sug-op-foot">
      <button class="sug-confirm-btn gray" (click)="closeWhy()">Cerrar</button>
      <button class="sug-confirm-btn green" *ngIf="canRequest" (click)="useFromWhy()">Usar sugerencia</button>
    </div>
  </div>
</div>

<!-- Modal de nueva solicitud prellenado (mismo mecanismo que el (+) del
     Inventario Real y Teórico): app-pipes en modo modalOnly solo pinta su
     modal; consume el prefill en su ngOnInit. -->
<app-pipes *ngIf="orderModalOpen" [modalOnly]="true" (modalClosed)="onOrderModalClosed($event)"></app-pipes>
